var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A181E",
    d: "M3.416 7.166c.505-.504 1.294-.55 1.85-.137l.16.137L12 13.74l6.574-6.574c.505-.504 1.294-.55 1.85-.137l.16.137c.504.505.55 1.294.137 1.85l-.137.16-7.58 7.579c-.504.504-1.293.55-1.85.137l-.159-.137-7.579-7.58c-.555-.554-.555-1.454 0-2.009z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/caret-down.c01296f37dca34e68e84bb8abce97d66.svg";
export { ForwardRef as ReactComponent };